// extracted by mini-css-extract-plugin
module.exports = {"modalOptionChip":"StylesModal_modalOptionChip__39F3e","resetArea":"StylesModal_resetArea__2BD-m"};